class AuthorizationFormController {
  /* @ngInject */
  constructor($stateParams, $http, $state) {
    this.$stateParams = $stateParams;
    this.$http = $http;
    this.$state = $state;
  }

  $onInit() {
    this.ignoreAuth = this.$state.current.name === 'public.case.authorizationForm';
  }

  remove() {
    this.file = undefined;
  }

  submit() {
    if (!this.file || this.submitting) return;

    const url = this.ignoreAuth
      ? `/public/case/${this.$stateParams.id}/response/${this.case.CaseResponse.id}/cif`
      : `/case/${this.$stateParams.id}/response/${this.case.CaseResponse.id}/cif`;

    this.submitting = true;

    this.file.filename = `CifSigned-${this.file.filename}`;
    this.$http.post(url, {
      attachment: {
        type: 'CifSigned',
        file: this.file,
      },
    }, { ignoreAuthModule: this.ignoreAuth })
      .then(() => {
        this.submitting = false;
        if (this.ignoreAuth) {
          this.$state.go('thank-you', {
            msg: 'Thank you, your response has been saved successfully.',
          });
        } else {
          this.$state.go('main.cases.view', { id: this.$stateParams.id });
        }
      })
      .catch(() => (this.submitting = false));
  }
}

export default AuthorizationFormController;



// WEBPACK FOOTER //
// ./client/app/cases/authorization-form/authorization-form.controller.js